export const reportLabel = {
  name: "Report",
  plural: "Reports",
  // Used in routes and navigation
  pathName: "report",
  value: "report",
  permissionKey: "trip",
};
